<template>
  <div>
    <div>
      <gameCmp 
        class="mainGameContainer"
        :gameData="gameData"
      ></gameCmp>

    <!-- Preloaded Images -->
    <div class="preloadImage testResultContainer" :class="resultID"></div>
    <img src="../../assets/images/games/wasp_game.png" alt="Preloaded Image" class="preloadImage">
    </div>
  </div>
</template>

<script>
import allGamesData from '../../assets/json/games.json'
import resultData from '../../assets/json/results.json'
export default {
  name: 'jumpGame',
  data() {
    return {
      gameData: allGamesData['jump'],
      resultID: null
    }
  },
  mounted () {
    let allAnswers = this.$store.getters.StoreQuestionData.questionArray
    if (allAnswers.length > 1) {
      this.result = resultData[allAnswers.sort((a,b) => allAnswers.filter(v => v===a).length - allAnswers.filter(v => v===b).length ).pop()]

      this.resultID = 'testResultContainer--' + this.result.id
    } else {
      this.restartTest()
    }
  }
}
</script>

<style scoped>
  .gameComplete.mainGameContainer:before {
    opacity: 1;
    top: 0;
    left: 0;
    right: -3px;
    bottom: -4px;
    background-image: url('../../assets/images/games/wasp_game.png');
  }
</style>